// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"e45ffc49","536":"5165c26c","941":"73ce0ee6","998":"3907aa55"}[chunkId] + ".chunk.js";
};